import React from 'react';
import {
	BodyContainer
} from '../components/StyledComponents/StyledComponents';
import Navigation from '../components/Navigation/Navigation.jsx';
import ProgressBar from '../components/ProgressBar/ProgressBar';
import AboutHero from '../components/About/AboutHero';
import AboutResume from '../components/About/AboutResume.jsx';
import Footer from '../components/Footer/Footer.jsx';

const About = () => {
    return (
		<>
			<ProgressBar/>
			<Navigation page="about" />
			<BodyContainer>
				<AboutHero />
				<AboutResume />
			</BodyContainer>
			<Footer />
		</>
    );
}

export default About;